const MapData = [
  { name: "Italic Text :", placeholder: "𝘱𝘳𝘦𝘷𝘪𝘦𝘸 𝘵𝘦𝘹𝘵" },
  { name: "BoldSans Text :", placeholder: "𝗽𝗿𝗲𝘃𝗶𝗲𝘄 𝘁𝗲𝘅𝘁" },
  { name: "Bold Text :", placeholder: "𝐩𝐫𝐞𝐯𝐢𝐞𝐰 𝐭𝐞𝐱𝐭" },
  { name: "BoldItalic Text :", placeholder: "𝙥𝙧𝙚𝙫𝙞𝙚𝙬 𝙩𝙚𝙭𝙩" },
  { name: "Winding Text :", placeholder: "🏱︎❒︎♏︎❖︎♓︎♏︎⬥︎ ❄︎♏︎⌧︎⧫︎" },
  { name: "FutureAlien Text :", placeholder: "ᕵᖇᘿᐺᓰᘿᘺ ᖶᘿ᙭ᖶ" },
  { name: "Squiggle 6 Text :", placeholder: "prēงiēຟ tēxt" },
  { name: "Squiggle 5 Text :", placeholder: "℘ཞɛ۷ıɛῳ ɬɛҳɬ" },
  { name: "AsianStyle 2 Text :", placeholder: "ｱ尺乇√ﾉ乇W ｲ乇ﾒｲ" },
  { name: "AsianStyle Text :", placeholder: "卩尺乇ᐯ丨乇山 ㄒ乇乂ㄒ" },
  { name: "Squares Text :", placeholder: "🄿🅁🄴🅅🄸🄴🅆 🅃🄴🅇🅃" },
  { name: "Squiggle 4 Text :", placeholder: "ᎮᏒᏋᏉᎥᏋᏇ ᏖᏋጀᏖ" },
  { name: "Squiggle 3 Text :", placeholder: "քʀɛʋɨɛա ȶɛӼȶ" },
  { name: "Bent Text :", placeholder: "քɾҽѵìҽա էҽ×է" },
  { name: "Greek Text :", placeholder: "ρяєνιєω тєχт" },
  { name: "Symbols Text :", placeholder: "þrêvïêw †êx†" },
  { name: "Currency Text :", placeholder: "₱ⱤɆVłɆ₩ ₮ɆӾ₮" },
  { name: "Squiggle 2 Text :", placeholder: "ρɾҽʋιҽɯ ƚҽxƚ" },
  { name: "Monospace Text :", placeholder: "𝚙𝚛𝚎𝚟𝚒𝚎𝚠 𝚝𝚎𝚡𝚝" },
  { name: "Neon Text :", placeholder: "ᑭᖇEᐯIEᗯ TE᙭T" },
  { name: "Wide Text :", placeholder: "ｐｒｅｖｉｅｗ ｔｅｘｔ" },
  { name: "OldEnglish Text :", placeholder: "𝔭𝔯𝔢𝔳𝔦𝔢𝔴 𝔱𝔢𝔵𝔱" },
  { name: "Cursive Text :", placeholder: "𝓹𝓻𝓮𝓿𝓲𝓮𝔀 𝓽𝓮𝔁𝓽" },
  { name: "InvertedSquares Text :", placeholder: "🅿🆁🅴🆅🅸🅴🆆 🆃🅴🆇🆃" },
  { name: "Medieval Text :", placeholder: "𝖕𝖗𝖊𝖛𝖎𝖊𝖜 𝖙𝖊𝖝𝖙" },
  { name: "DoubleStruck Text :", placeholder: "𝕡𝕣𝕖𝕧𝕚𝕖𝕨 𝕥𝕖𝕩𝕥" },
  { name: "Squiggle Text :", placeholder: "קгєשเєฬ ՇєאՇ" },
  { name: "Superscript Text :", placeholder: "ᵖʳᵉᵛⁱᵉʷ ᵗᵉˣᵗ" },
  { name: "UpperAngles Text :", placeholder: "PЯΣVIΣЩ ƬΣXƬ" },
  { name: "Subscript Text :", placeholder: "ₚᵣₑᵥᵢₑw ₜₑₓₜ" },
  { name: "Vaporwave Text :", placeholder: "ｐｒｅｖｉｅｗ　ｔｅｘｔ" },
];

export default MapData;
